// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const RUN_SCIENTIFIC_MODEL_STEP_SHAPES = [
  {
    stepType: PipelineStepType.RUN_SCIENTIFIC_MODEL,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      inputDataset: {
        systemName: 'inputDataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      outputDataset: {
        systemName: 'outputDataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      predictionBatchFolderId: {
        kind: 'domain',
        required: true,
        types: [
          'FOLDER'
        ]
      },
      predictionBatchName: {
        kind: 'string',
        required: false
      },
      modelConfig: {
        kind: 'taggedUnion',
        required: true,
        tagKey: 'model',
        choices: [
          {
            kind: 'shape',
            required: true,
            fields: {
              model: {
                kind: 'string',
                required: true,
                value: 'deepsp'
              },
              heavyChainColumn: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'inputDataset',
                allowMissingColumn: false,
                validationOptions: {
                  allowedLeafTypes: [
                    LeafType.TEXT
                  ],
                  listType: ColumnTypeValidationFlag.NOT_ALLOWED
                }
              },
              lightChainColumn: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'inputDataset',
                allowMissingColumn: false,
                validationOptions: {
                  allowedLeafTypes: [
                    LeafType.TEXT
                  ],
                  listType: ColumnTypeValidationFlag.NOT_ALLOWED
                }
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              model: {
                kind: 'string',
                required: true,
                value: 'tunelab:ablab'
              },
              heavyChainColumn: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'inputDataset',
                allowMissingColumn: false,
                validationOptions: {
                  allowedLeafTypes: [
                    LeafType.TEXT
                  ],
                  listType: ColumnTypeValidationFlag.NOT_ALLOWED
                }
              },
              lightChainColumn: {
                kind: 'columnReference',
                required: true,
                inputDataName: 'inputDataset',
                allowMissingColumn: false,
                validationOptions: {
                  allowedLeafTypes: [
                    LeafType.TEXT
                  ],
                  listType: ColumnTypeValidationFlag.NOT_ALLOWED
                }
              }
            }
          }
        ]
      }
    }
  },
  {
    stepType: PipelineStepType.RUN_SCIENTIFIC_MODEL,
    isDeprecated: false,
    version: 1,
    inputDataShapes: {
      inputDataset: {
        systemName: 'inputDataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      outputDataset: {
        systemName: 'outputDataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      predictionBatchFolderId: {
        kind: 'domain',
        required: true,
        types: [
          'FOLDER'
        ]
      },
      predictionBatchName: {
        kind: 'string',
        required: false
      },
      modelConfig: {
        kind: 'anything',
        required: true
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
